import QRCode from "react-qr-code";
import React from "react";

interface QrCodeProps {
  title: string;
  path: string;
  subtitles?: string[];
}

const QrCode = React.forwardRef<HTMLDivElement, QrCodeProps>(({ title, path, subtitles }, ref) => {
  return (
    <div ref={ref} className="m-8 flex flex-col items-center gap-4 pl-6">
      <div className="flex flex-col flex-wrap text-center">
        <h1 className="text-2xl">{title}</h1>
        {subtitles &&
          subtitles.map((s) => (
            <h1 className="text-1xl" key={s}>
              {s}
            </h1>
          ))}
      </div>
      <QRCode value={path} size={200} className="my-8" />
    </div>
  );
});

QrCode.displayName = "QrCode";

export default QrCode;
